import { types } from "../../types/types";

const initialState = {
    cargada:false,
    items: [],
    loading: false,
    error: null
};

export const tipoRelacionReducer = (state = initialState, action) => {   
    switch (action.type) {
        case types.traerTipoRelacion:
          return {
            ...state,
            cargada:true,
            items: action.payload.afiliaciones.filter(item => (item.idSituacionRevista===action.payload.idCategoria && item.marcado===true))
          };
        default:
          return state;
      }
};
